import { type Theme } from '@mui/material/styles'
export const getLayoutConfig = (theme: Theme) => {
  return {
    CostOfLivingToIncome: {
      secondaryColor: theme.palette.divider,
    },
    MonthlyDepositSummaryV2: {
      colors: [theme.palette.success.main, theme.palette.success.light],
    },
    MonthlyNonEssentialCategorySummaryV2: {
      colors: [theme.palette.chartMono.chartMono3, theme.palette.chartMono.chartMono5],
    },
    CreditCardCloseToLimit: {
      colors: [theme.palette.warning.main, theme.palette.divider],
    },
    CreditUtilization: {
      dynamicPrimary: 'creditUtilization',
      secondaryColor: theme.palette.divider,
    },
  }
}
